/**
 * RecycleGem use case: remove gem from tower slot and reclaim partial mana.
 */

import { recycleGemFromSlot } from "../../domain/session.js";
import type { RecycleGemError } from "../../domain/types.js";
import type { RenderPort } from "../ports.js";
import { sessionToView } from "../state-view.js";
import type { GemSlot } from "../types.js";

export interface RecycleGemDeps {
  render: RenderPort;
  getSession(): import("../../domain/session.js").GameSession | null;
}

export function createRecycleGem(deps: RecycleGemDeps) {
  return function recycleGem(slot: GemSlot): { ok: true } | RecycleGemError {
    const session = deps.getSession();
    if (!session) return { code: "InvalidSlot" };
    const mana = recycleGemFromSlot(session, slot.towerId, slot.slotIndex);
    if (mana === 0) return { code: "InvalidSlot" };
    deps.render.update(sessionToView(session, "game"));
    return { ok: true };
  };
}
